/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StorageNodeUpdate
 */
export interface StorageNodeUpdate {
    /**
     * 
     * @type {string}
     * @memberof StorageNodeUpdate
     */
    name?: string;
    /**
     * For communication between nodes only
     * @type {string}
     * @memberof StorageNodeUpdate
     */
    address?: string;
    /**
     * Enforces mounting from a specific address/hostname instead of the available interfaces
     * @type {string}
     * @memberof StorageNodeUpdate
     */
    addressOverride?: string | null;
    /**
     * 
     * @type {number}
     * @memberof StorageNodeUpdate
     */
    type?: StorageNodeUpdateTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof StorageNodeUpdate
     */
    ipmi?: StorageNodeUpdateIpmiEnum;
    /**
     * Run volume-specific tasks for selected volumes.
     * @type {Array<number>}
     * @memberof StorageNodeUpdate
     */
    volumeQueues?: Array<number>;
}

/**
* @export
* @enum {string}
*/
export enum StorageNodeUpdateTypeEnum {
    NUMBER_1 = 1,
    NUMBER_2 = 2,
    NUMBER_3 = 3
}/**
* @export
* @enum {string}
*/
export enum StorageNodeUpdateIpmiEnum {
    NUMBER_1 = 1,
    NUMBER_2 = 2,
    NUMBER_3 = 3
}

export function StorageNodeUpdateFromJSON(json: any): StorageNodeUpdate {
    return StorageNodeUpdateFromJSONTyped(json, false);
}

export function StorageNodeUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): StorageNodeUpdate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'address': !exists(json, 'address') ? undefined : json['address'],
        'addressOverride': !exists(json, 'address_override') ? undefined : json['address_override'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'ipmi': !exists(json, 'ipmi') ? undefined : json['ipmi'],
        'volumeQueues': !exists(json, 'volume_queues') ? undefined : json['volume_queues'],
    };
}

export function StorageNodeUpdateToJSON(value?: StorageNodeUpdate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'address': value.address,
        'address_override': value.addressOverride,
        'type': value.type,
        'ipmi': value.ipmi,
        'volume_queues': value.volumeQueues,
    };
}


